// 무한의 탑 51~100층 테마 분위기(3개월 C5): 지도(지역4) 분위기에 10층 구간 테마 색(content/towerHigh.ts TOWER_THEMES)을 섞는다.
// 지형·소품은 그대로이고 배경·안개·햇빛·그늘 색만 층 구간마다 달라진다. 1~50층과 일반 지도는 null(원래 분위기 그대로).
import { towerThemeOf } from '../../shared/content/towerHigh';
import type { MapMood } from './mood';

/** 스테이지 id 'tower:<층>' → 층 번호(아니면 0) */
export function towerFloorOfStage(stageId: string): number {
  if (!stageId.startsWith('tower:')) return 0;
  const f = Number(stageId.slice(6));
  return Number.isInteger(f) ? f : 0;
}
/** 렌더가 층 구간 바뀜을 알아채는 키('' = 테마 없음) */
export function towerThemeKey(stageId: string): string { return towerThemeOf(towerFloorOfStage(stageId))?.id ?? ''; }

/** 0xRRGGBB 두 색을 t(0..1)로 섞는다 */
export function lerpHex(a: number, b: number, t: number): number {
  const ch = (x: number, s: number): number => (x >> s) & 255;
  const m = (s: number): number => Math.round(ch(a, s) + (ch(b, s) - ch(a, s)) * t) & 255;
  return (m(16) << 16) | (m(8) << 8) | m(0);
}

export function towerMoodOf(stageId: string, base: MapMood): MapMood | null {
  const th = towerThemeOf(towerFloorOfStage(stageId));
  if (!th) return null;
  const k = th.mix;
  return {
    ...base,
    bg: lerpHex(base.bg, th.bg, k),
    fog: lerpHex(base.fog, th.fog, k),
    haze: lerpHex(base.haze, th.fog, k),
    sun: lerpHex(base.sun, th.sun, k),
    hemiSky: lerpHex(base.hemiSky, th.sun, k * 0.5),
    hemiGround: lerpHex(base.hemiGround, th.bg, k),
    glow: lerpHex(base.glow, th.sun, k),
    shadowTint: lerpHex(base.shadowTint, th.fog, k * 0.6),
  };
}
